module.exports = __webpack_public_path__ + "static/media/coral-2.a5c5baac.png";